import {Injectable} from '@angular/core';
import {Observable, Subject, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {ErrorInfo, isErrorInfo} from '../../model/error-info';


@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  errorStream$ = new Subject<ErrorInfo>();

  public bindErrorHandling<T>(call$: Observable<T>): Observable<T>{

    return call$.pipe(catchError(err => {

      const errorInfo = this.toErrorInfo(err);
      this.errorStream$.next(errorInfo);
      return throwError(() => errorInfo);
      //  wir wollen an dieser stelle keinen catchAll haben und nichts weiter machen
      //  Aufrufer sollen die Möglichkeit haben, eigenes Fehlerhandling zu machen
    }));
  }

  public toErrorInfo(err: unknown): ErrorInfo {
    if (isErrorInfo(err)) {
      return err;
    }

    // Aktuell haben wir noch keine echte Konvertierung, weil sie nicht zur Fehlerausgabe herangezogen wird.
    return {
      errorCode: 500,
      errorText: 'Unknown Error',
      errorLink: '',
      errorLinkText: ''
    };
  }

}
